// extracted by mini-css-extract-plugin
export default {"pageContainer":"SuggestIdeaPage_pageContainer__l6tY8","ideaForm":"SuggestIdeaPage_ideaForm__U7b8S"};